<template>
	<page-container :page="page">
		<video-header v-if="page.vimeoIDLandscape" :embed-code="page.vimeoIDLandscape" type="large">
			<template #heroContent>
				<div v-if="defaults[locale].homepage.headingTitle" class="hero-content">
					<span class="hero-title">
						{{ defaults[locale].homepage.headingTitle }}
					</span>
					<span class="hero-subtitle">
						{{ defaults[locale].homepage.headingSubTitle }}
					</span>
				</div>
			</template></video-header
		>
		<heading-image
			v-else-if="page.headingImage"
			:fullpage="true"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		>
			<template #heroContent>
				<div v-if="defaults[locale].homepage.headingTitle" class="hero-content">
					<span class="hero-title">
						{{ defaults[locale].homepage.headingTitle }}
					</span>
					<span class="hero-subtitle">
						{{ defaults[locale].homepage.headingSubTitle }}
					</span>
				</div>
			</template>
		</heading-image>

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:introduction-content="page.introductionContent"
		>
			<template #bgImage>
				<picture>
					<source srcset="/images/bg-index.webp" type="image/webp" />
					<source srcset="/images/bg-index.jpg" />
					<img class="fade-image" src="/images/bg-index.webp" alt="Booking benefits" loading="lazy" />
				</picture>
			</template>
		</main-content>

		<booking-benefits
			:title="defaults[locale].homepage.sectionBenefitsTitle"
			:subtitle="defaults[locale].homepage.sectionBenefitsSubtitle"
			:benefits="defaults[locale].homepage.bookingBenefits"
			:book-button-label="defaults[locale].website.book"
			:image="{
				image: defaults[locale].homepage.sectionBenefitsImage,
				imageAlt: defaults[locale].homepage.sectionBenefitsImageAlt,
				imageWebp: defaults[locale].homepage.sectionBenefitsImageWebp,
			}"
		/>

		<rooms-promotions
			:items="roomsData"
			:title="defaults[locale].rooms.sectionRoomsTitle"
			:subtitle="defaults[locale].rooms.sectionRoomsSubtitle"
			:content="defaults[locale].rooms.sectionRoomsContent"
			:button-label="defaults[locale].rooms.more"
		/>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:content="page.sectionContentblocksContent"
			:subtitle="page.sectionContentblocksSubtitle"
			:title="page.sectionContentblocksTitle"
		/>

		<!-- <promoblocks
			:title="defaults[locale].homepage.sectionPromotionTitle"
			:subtitle="defaults[locale].homepage.sectionPromotionSubtitle"
			:promoblocks="promoblocksData"
			:amount="4"
		/> -->

		<newsletter
			v-if="page && page.showNewsletter"
			:formid="defaults[locale].newsletter.mailChimpID"
			:link="defaults[locale].newsletter.mailChimpLink"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>

		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:subtitle="page.frequentlyAskedQuestion.subtitle"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

// const { data: promoblocksData } = await useWebsiteFetch('promoblocks', {
// 	query: { language: locale.value },
// 	key: `${locale.value}/promoblocks`,
// });

const { data: roomsData } = await useWebsiteFetch('rooms', {
	query: { language: locale.value },
	key: `${locale.value}/rooms`,
});
</script>

<style lang="scss" scoped>
.hero-content {
	position: absolute;
	inset: 0;
	display: flex;
	flex-flow: column;
	justify-content: center;
	left: 0;
	right: 0;
	z-index: 3;
	text-align: center;
	padding: 0 20px;
	color: var(--header-color);
}

.hero-content span {
	color: var(--color-silk);
	font-weight: 400;
	font-size: 72px;
	letter-spacing: 1px;
	width: 100%;
	font-family: var(--heading-font-family);
	display: inline-block;
	margin: 0 0 10px;
}

.hero-content .hero-title {
	font-size: var(--font-size-hero);
	animation: fade-from-bottom 1.2s ease;
}

.hero-content .hero-subtitle {
	font-size: var(--subtitle-font-size);
	font-weight: 300;
	font-family: var(--body-font-family);
	color: #fff;
	animation: fade-from-bottom 1s ease 0.5s both;
}
</style>
